import { render, staticRenderFns } from "./tablelist.vue?vue&type=template&id=72716d26"
import script from "./tablelist.vue?vue&type=script&lang=js"
export * from "./tablelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports